import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { RoomType } from './room-type.model';
import { RoomTypesModalComponent } from '../components/room-types-modal/room-types-modal.component';
import { RoomTypeModalComponent } from '../components/room-type-modal/room-type-modal.component';
import { RoomTypeTranslationModalComponent } from '../components/room-type-translation-modal/room-type-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class RoomTypeModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openRoomTypesModal(successCallback) {
    const options = {
      width: '700px', // 1000px
      minHeight: '80vh',
      maxHeight: '80vh',
      position: { top: '5vh' },
      disableClose: true,
      data: {
        title: 'ROOM_TYPES',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, RoomTypesModalComponent);
  }

  openRoomTypeModal(
    roomType: RoomType,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (roomType.id) {
        roomType.name = result.name;
        roomType.description = result.description;

        return this.utilService.changeItemRowStyle(roomType.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'ROOM_TYPE_DETAILS',
        obj: roomType,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, RoomTypeModalComponent);
  }

  openRoomTypeTranslation(roomType: RoomType, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'ROOM_TYPE_DETAILS',
        obj: roomType,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, RoomTypeTranslationModalComponent);
  }
}
